import { RegisterSceneLoaderPlugin } from "@babylonjs/core/Loading/sceneLoader";
import { PmdReader } from "./Parser/pmdReader";
import { PmdLoaderMetadata } from "./pmdLoader.metadata";
import { PmLoader } from "./pmLoader";
/**
 * PmdLoader is a loader that loads the model in the PMD format
 *
 * PMD is a binary file format that contains all the data except the texture of the model
 */
export class PmdLoader extends PmLoader {
    /**
     * Create a new PmdLoader
     *
     * @param options babylon.js scene loader options
     * @param loaderOptions Overriding options, typically pass global PmdLoader instance as loaderOptions
     */
    constructor(options, loaderOptions) {
        super(PmdLoaderMetadata.name, PmdLoaderMetadata.extensions, options, loaderOptions);
    }
    createPlugin(options) {
        return new PmdLoader(options.mmdmodel, this);
    }
    async _parseFileAsync(arrayBuffer) {
        return await PmdReader.ParseAsync(arrayBuffer, this)
            .catch((e) => {
            return Promise.reject(e);
        });
    }
}
RegisterSceneLoaderPlugin(new PmdLoader());
